import initialState from './initialState'
import {
  FETCH_NEWS,
  FINISH_FETCH_NEWS,
  BEGIN_FETCH_NEWS,
} from '../actions/actionTypes'

export default function newsStuff(state = initialState.news, action) {
  switch (action.type) {
    case BEGIN_FETCH_NEWS:
      return { ...state, isLoading: true }
    case FETCH_NEWS:
      return { ...state, news: action.news }
    case FINISH_FETCH_NEWS:
      return { ...state, isLoading: false }

    default:
      return state
  }
}
